import clsx from 'clsx'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { PriceProps } from './type'

export const ItemPrice = ({
  item,
  cartSalesTypeQuantities,
  direction,
  showCount = true,
}: PriceProps) => {
  const { t } = useTranslation()
  const count = useMemo(
    () =>
      cartSalesTypeQuantities
        ? cartSalesTypeQuantities.reduce(
            (sum, current) => (sum += current.quantity),
            0
          )
        : 0,
    [cartSalesTypeQuantities]
  )

  const summarySalonPrice = useMemo(() => {
    if (!item.salonPrice || !cartSalesTypeQuantities) {
      return 0
    }

    return item.salonPrice * count
  }, [item, cartSalesTypeQuantities, count])

  switch (direction) {
    case 'horizontal': {
      return (
        <div
          className={clsx('tw-flex tw-flex-wrap tw-items-center', 'tw-gap-x-1')}
        >
          <div
            className={clsx(
              'tw-flex tw-flex-wrap tw-items-center',
              'tw-gap-x-4'
            )}
          >
            {showCount && (
              <p className={clsx('tw-text-xs tw-text-gray-600')}>
                {`${t('item.order.quantity')}：${count}${t(
                  'item.order.units'
                )}`}
              </p>
            )}

            <p className={clsx('tw-text-xs tw-text-gray-600')}>
              {`${t('item.order.salonPrice')}：${(
                item.salonPrice || 0
              ).toLocaleString()}${t('item.order.currency')}`}
            </p>
            {cartSalesTypeQuantities && (
              <p className={clsx('tw-text-xs tw-text-gray-600')}>
                {`${t(
                  'item.detail.subtotal'
                )}：${summarySalonPrice.toLocaleString()}${t(
                  'item.order.currency'
                )}`}
              </p>
            )}
          </div>
        </div>
      )
    }
    case 'vertical': {
      return (
        <table className={clsx('tw-text-sm', 'tw-table-fix', 'tw-w-full')}>
          {showCount && (
            <tr>
              <td>{t('item.order.quantity')}</td>
              <td className={clsx('tw-min-w-[120px] tw-text-right')}>
                {count}
                {t('item.order.units')}
              </td>
            </tr>
          )}
          <tr className={clsx('tw-text-gray-600')}>
            <td>{t('item.order.salonPrice')}</td>
            <td className={clsx('tw-min-w-[120px] tw-text-right')}>{`${(
              item.salonPrice || 0
            ).toLocaleString()}${t('item.order.currency')}`}</td>
          </tr>
          {cartSalesTypeQuantities && (
            <tr className={clsx('tw-text-gray-600')}>
              <td>{t('item.detail.subtotal')}</td>
              <td
                className={clsx('tw-min-w-[120px] tw-text-right')}
              >{`${summarySalonPrice.toLocaleString()}${t(
                'item.order.currency'
              )}`}</td>
            </tr>
          )}
        </table>
      )
    }
    default: {
      return <></>
    }
  }
}
